module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "ethereum1.6a72ab43.svg";